import Link from 'next/link'

import { cx } from '@/app/lib/utils'

import type { PurchaseCtaProps } from './types'
import styles from './PurchaseCta.module.scss'

/**
 * `PurchaseCta` — botón de compra compartido entre `VerticalCard` y
 * `HorizontalCard`. Estado habilitado: enlace a `ctaHref ?? href`. Estado
 * deshabilitado (`ctaDisabled`, o sin destino resuelto — ver abajo):
 * `<button disabled>` nativo, sin navegación, sin JS de cliente (Server
 * Component).
 */
export function PurchaseCta({
  href,
  ctaLabel,
  ctaHref,
  ctaDisabled = false,
  fullWidth = true,
  className,
}: PurchaseCtaProps) {
  const ctaClassName = cx(styles.cta, fullWidth && styles.fullWidth, className)
  const resolvedHref = ctaHref ?? href

  // `ctaDisabled` y "destino resuelto" son dos señales independientes
  // (`resolvePurchaseState` vs. la disponibilidad de `purchase_url`/PDP) — un
  // producto comprable puede llegar sin ninguno de los dos destinos (p. ej.
  // sin `genres` y sin `purchase_url`). Sin este guard se pintaría un botón
  // habilitado que enlaza a `""` (la propia página), igual de "muerto" que el
  // enlace que el título ya evita (ver `VerticalCard`/`HorizontalCard`).
  if (ctaDisabled || !resolvedHref) {
    return (
      <button type="button" disabled className={ctaClassName}>
        {ctaLabel}
      </button>
    )
  }

  return (
    // `data-purchase-cta`: marca para que `TrackedProductCard` distinga este CTA
    // (→ `add_to_cart`) del enlace del título (→ solo `select_item`).
    <Link href={resolvedHref} className={ctaClassName} data-purchase-cta>
      {ctaLabel}
    </Link>
  )
}
